module.exports = __webpack_public_path__ + "media/images/camera-btn-3d926cdb8d3f15013b04032cf9bb13c9d2e102241f982a276361b3a377d38bd1.svg";